import { APIInterfaceI, buildRequest, PaginationT } from '.';

class flows implements APIInterfaceI {
  getOne = (targetId: string) => (
    buildRequest('GET', `/scenarios/${targetId}`)
  )

  getAll = (pagination: PaginationT) => (
    buildRequest('GET', `/scenarios?cursor=${pagination.cursor}&limit=${pagination.limit}`)
  )

  delete = (targetId: string) => (
    buildRequest('DELETE', `/scenarios/${targetId}`)
  )

  register = (formData: any) => (
    buildRequest('POST', '/scenarios', formData)
  )

  update = (targetId: string, formData: any) => (
    buildRequest('PUT', `/scenarios/${targetId}`, formData)
  )
}

export default flows;
